// extracted by mini-css-extract-plugin
export default {"container":"pagination_container__7259o","btn":"pagination_btn__nFjms","active":"pagination_active__He26T"};